export enum CustomerStatusEnum {
  UNKNOWN = "unknown",
  ACTIVE = "active",
  INACTIVE = "inactive",
}
